/** Get video id from youtube url string */
const getVideoIdFromYoutubeUrl = (url: string) => {
  var regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return (match && match[7]) || "";
};

export { getVideoIdFromYoutubeUrl };
